import React from 'react';
import cx from 'classnames';
import imageSrc from '../../common/image';

function FooterMobile(props) {
  const years = new Date().getFullYear();
  return (
    <footer className={cx('w-full bg-brand-grey-200', props.className)}>
      <div className="container py-8">
        <figure className="w-20 mb-3">
          <img loading="lazy" src={`${imageSrc}/logo/footer_logo.svg`} alt="LINE TV" className="w-full h-auto" />
        </figure>
        <small className="text-12 font-500">
          Copyright&copy;{years} CHOCO Media Co. Ltd.
          <br />
          ALL RIGHTS RESERVED.
        </small>
      </div>
    </footer>
  );
}

export default FooterMobile;
